/* AWARE Trial Kit v10 - scroll motion (IntersectionObserver). Guarded to init once
   even if loaded by multiple sections. Reveals .v9-animate on enter; data-delay staggers. */
(function () {
  if (window.__awareTkMotion) return;
  window.__awareTkMotion = true;
  function init() {
    var els = document.querySelectorAll('.v9-animate');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      for (var i = 0; i < els.length; i++) { els[i].classList.add('v9-in'); }
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        var d = parseInt(el.getAttribute('data-delay') || '0', 10);
        if (d > 0) { el.style.transitionDelay = (d * 80) + 'ms'; }
        el.classList.add('v9-in');
        io.unobserve(el);
      });
    }, { threshold: 0.15 });
    els.forEach(function (el) { io.observe(el); });
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); }
  else { init(); }
})();
